import axios from 'axios'
import store from '@/store'

const instance = axios.create({
  baseURL: process.env.API_SERVER
})

instance.interceptors.request.use(
  (config) => {
    if (store.getters.currentToken) {
      config.headers['Authorization'] = 'Bearer ' + store.getters.currentToken
    }
    return config
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error)
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/server.js